module.exports = __webpack_public_path__ + "h5/img/icon_ad.bd4223fc.png";